<!-- eslint-disable vue/valid-template-root -->
<!-- eslint-disable prettier/prettier -->
<template>
  <div class="container-verify">
    <div class="breakpoint-verify">
      <div class="d-flex justify-center" v-if="logo_tb">
        <img :src="white_label.status ? white_label.logo : logo_tb.src" height="100px" alt="logo-temanbakat" />
      </div>
      <p class="text-center title_verify">Verifikasi Tanda Tangan Elektronik</p>
      <p class="text-center _verify" v-if="dataSet">
        {{ white_label.status ? white_label.company_name : 'PT Hara Anargya Indonesia' }} menyatakan bahwa:
      </p>
      <v-card class="card_info rounded-lg" elevation="1" v-if="!loading">
        <div v-if="dataSet">
          <p class="text-center title_pernyataan">
            Proses, norma dan hasil tes terverifikasi oleh <br />
            tim Psikolog {{ white_label.status ? white_label.company_name : 'Teman Bakat' }}
          </p>
            <div>
              <p class="mb-0 small_txt">Nama Dokumen:</p>
              <p class="font-weight-bold">
                {{ dataSet.filename }}
              </p>
            </div>
            <div v-if="white_label.status == false">
                <p class="mb-0 small_txt">Disahkan pada tanggal:</p>
                <p class="font-weight-bold">{{ dataSet.created_at }}</p>
              </div>
            <p class="mb-0 small_txt">Verifikator:</p>
          <v-card class="pa-3 d-flex align-center" flat color="#fafafa">
            <v-avatar size="56">
              <img
                :src='white_label.status ? white_label.logo : logo_tb.src'
                alt="logo-temanbakat"
              />
            </v-avatar>
            <div class="ml-3">
              <p class="mb-0 font-weight-bold">Tim Psikolog {{ white_label.status ? white_label.company_name : 'Teman Bakat' }}</p>
            </div>
          </v-card>
          <div class="py-2">
            <v-divider></v-divider>
          </div>
          <v-card outlined class="pa-3">
            <v-row>
              <v-col cols="12">
                <p class="mb-0 small_txt">Nama Layanan:</p>
                <p class="mb-0 font-weight-bold">{{ dataSet.layanan }}</p>
              </v-col>
              <v-col cols="6">
                <p class="mb-0 small_txt">ID Transaksi:</p>
                <p class="mb-0 font-weight-bold">{{ dataSet.id_trx }}</p>
              </v-col>
              <v-col cols="6">
                <p class="mb-0 small_txt">ID Pelanggan:</p>
                <p class="mb-0 font-weight-bold">{{ dataSet.id_pelanggan }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="mb-0 small_txt">Nama Peserta:</p>
                <p class="mb-0 font-weight-bold">{{ dataSet.nama_peserta }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="mb-0 mb-0 small_txt">Tanggal Tes:</p>
                <p class="font-weight-bold">{{ dataSet.tgl_tes }}</p>
              </v-col>
            </v-row>
          </v-card>
          <div class="d-flex mt-10" style="justify-content: end; align-items: start;" v-if="white_label.status">
            <div style="min-width: 200px;">
              <div class="text-center">
                <p class="mb-0 small_txt">Disahkan pada tanggal:</p>
                <p class="font-weight-bold small_txt">{{ dataSet.created_at }}</p>
              </div>
              <div class="text-center">
                <img :src="white_label.psikolog['ttd']" alt="" style="width: 150px; object-fit: fill;"></img>
              </div>
              <div>
                <p class="small_txt text-center mb-0 p-0 font-weight-bold">{{white_label.psikolog['name']}}</p>
                <p class="small_txt text-center mb-0 p-0">No. SIPP: {{white_label.psikolog['sipp']}}</p>
              </div>
            </div>
          </div>
        </div>
        <h3 class="text-center" v-else>Token tidak valid!</h3>
      </v-card>
      <v-skeleton-loader
        v-else
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerifyEsignature",
  data() {
    return {
      white_label: {},
      dataSet: null,
      loading: false,
      logo_tb: null,
    };
  },
  mounted() {
    let logo = require("../../assets/img/logo-teman-bakat.png");
    let img = new Image();
    img.src = logo;
    this.logo_tb = img;
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      let token = this.$route.params.id;
      let body = {
        path: `verifikasi-qrcode?code=${token}&include=dataPelanggan2,dataJawabanPelanggan`,
      };
      this.$store
        .dispatch("getApi", body)
        .then((data) => {
          let res = data.data;
          let body = {
            filename: `${res.path_report}.pdf`,
            created_at: this.$date(res.created_at).format("D MMMM YYYY"),
            tgl_tes: this.$date(res.data_jawaban_pelanggan.created_at).format(
              "YYYY-MM-DD HH:mm",
            ),
            layanan:
              JSON.parse(res.transaksi).paket.psikotes.nama_psikotes ?? "-",
            id_trx: res.id,
            id_pelanggan: res.id_pelanggan,
            nama_peserta: res.data_pelanggan2.nama ?? "-",
          };
          this.dataSet = body;
          this.loading = false;
          this.white_label = {
            status: res.voucher?.is_white_label === 1 ? true : false,
            logo: res.grup?.logo_path,
            company_name: res.grup?.nama,
            psikolog: {
              name: res.klien?.nama,
              sipp: res.klien?.sipp,
              ttd: res.klien?.ttd_path,
            },
          };
          console.log(this.white_label.psikolog.name);
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.title_verify {
  font-size: 25px;
}
.title_pernyataan {
  font-size: 23px;
}
.container-verify {
  width: 100%;
  display: flex;
  justify-content: center;
}
.breakpoint-verify {
  padding: 30px 30px;
  width: 55%;
}
.card_info {
  padding: 28px;
}
@media (max-width: 576px) {
  .breakpoint-verify {
    padding: 10px;
    width: 100%;
    min-height: 100vh;
  }
  .card_info {
    padding: 20px;
  }
}
</style>
